import { render, staticRenderFns } from "./InfoView_AboutUs.vue?vue&type=template&id=82650180&"
import script from "./InfoView_AboutUs.vue?vue&type=script&lang=js&"
export * from "./InfoView_AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./InfoView_AboutUs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports